export const BuyingTools = {
  title: 'เครื่องมือสำหรับการซื้อรถ',
  searchAndCompare: 'ค้นหาและเปรียบเทียบ',
  dealer: 'ค้นหาโชว์รูม / ศูนย์บริการ',
  downloadBrochure: 'ดาวน์โหลดโบรชัวร์',
  sellSecondHandCar: 'ขายรถมือสอง',
} as const;

export const NavigationMenuLabel = {
  model: 'รุ่นรถบรรทุก',
  offer: 'ข้อเสนอพิเศษ',
  lcs: 'ไลฟ์ไซเคิล โซลูชัน',
  serviceAndOffer: 'บริการและสิทธิประโยชน์',
  share: 'แชร์สิ่งดีๆ',
  aboutus: 'เกี่ยวกับอีซูซุ',
  online: 'ช่องทางติดต่อออนไลน์',
} as const;

export const NavigationMenuLabelLcsGroup = {
  buy: 'ซื้อรถบรรทุกอย่างคุ้มค่า',
  cost: 'ลดต้นทุนตลอดการใช้งาน',
  service: 'บริการมาตรฐานราคาประหยัด',
  sell: 'ขายต่อขายง่ายได้ราคา',
} as const;

export const NavigationMenuLabelLcs = {
  showroom: 'โชว์รูม',
  service: 'ศูนย์บริการ',
  leasing: 'ตรีเพชรอีซูซุลิสซิ่ง',
  rbsc: 'หน่วยงานสนับสนุนด้าน<span>ตัวถัง</span>',
  ilsc: 'ศูนย์อบรมการใช้รถบรรทุกอย่าง<span>มืออาชีพ</span>',
  teletec: 'เทเลเทค',
  parts: 'อะไหล่แท้ตรีเพชร',
  care: 'แพ็กเกจอีซูซุแคร์',
  serviceline: 'ISUZU Truck Service Line',
  truck2hand: 'Truck2Hand',
} as const;
